import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IIntegration } from "../models/integration/Integration";

export default function useIntegrations() {
  const { get } = useApiHelper();

  const integrations = useQuery({
    queryKey: ["integrations"],
    queryFn: () => get<DefaultResponseWithData<IIntegration[]>>("/integration"),
  });

  return {
    integrations
  }

}